import React, { Component } from "react";

import "./Suggestion.component.scss";

export interface SuggestionProps {
    onAnchorClick: () => void;
    questionText: string;
    anchorText: string;
}

export default class Suggestion extends Component<SuggestionProps, {}> {
    render() {
        return (
            <div id="Suggestion">
                <div className="extra">
                    <span className="extra-prompt">
                        {this.props.questionText}
                        <a onClick={this.props.onAnchorClick}>
                            {this.props.anchorText}
                        </a>
                    </span>
                </div>
            </div>
        );
    }
}
